import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from "axios";
import { baseUrl } from './config';
import Cookies from 'js-cookie';

export const MemberInsert = createAsyncThunk(
    '/MemberInsert',
    async (data) => {
        let url = baseUrl+'contactRequest';
        const token=Cookies.get("token");
      try {
        const response = (await axios.post(url,data,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        })).data

        if(response.status === "success"){
            return Promise.resolve(response)
        } else if(response.status === "error") {
            return Promise.resolve(response)
        }else{
          return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );

  export const MemberUpdate = createAsyncThunk(
    '/MemberUpdate',
    async (data) => {
        let url = baseUrl+'contactUpdate';
        const token=Cookies.get("token");
      try {
        const response = (await axios.post(url,data,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        })).data

        if(response.status === "success"){
            return Promise.resolve(response)
        } else if(response.status === "error") {
            return Promise.resolve(response)
        }else{
          return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );

  export const GetMembers = createAsyncThunk(
    '/GetMembers',
    async (data) => {
        let url = baseUrl+'getcontacts';
        const token=Cookies.get("token");
      try {
        const response = (await axios.post(url,data,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        })).data

        if(response.status == "success"){
    
            return Promise.resolve(response)
            
        } else if(response.status === "error") {
            return Promise.resolve(response)
        }else{
          return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );

  export const DeletetMembers = createAsyncThunk(
    '/DeletetMembers',
    async (data) => {
        let url = baseUrl+'deleteContact';
        const token=Cookies.get("token");
      try {
        const response = (await axios.post(url,data,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        })).data

        if(response.status == "success"){
    
            return Promise.resolve(response)
            
        } else if(response.status === "error") {
            return Promise.resolve(response)
        }else{
          return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );

  export const IsCompanyExist = createAsyncThunk(
    '/isCompanyExist',
    async(data, {rejectWithValue}) => {
      let url = baseUrl + 'isCompanyExist';
      let token = Cookies.get("token");

      try{
        const response = (await axios.post(url, data, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        })).data;
        console.log("TST: ", response)
        if (response.status === "error") {
          return Promise.reject(response);
        }

        return Promise.resolve(response);
      }catch(err){
        return rejectWithValue(err.response?.message || { status: false, message: "API error" });
      }
    }
  )


